import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { SharedFunctions } from '../shared.functions';
import { Banco, SaveBancoDto, SearchBancoRequest } from '../model';

@Injectable({
  providedIn: 'root'
})
export class BancoService extends CrudService<Banco, number, SaveBancoDto, SearchBancoRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'banco', sharedFunctions);
  }
}
